'use strict';

/**
 * Suggestions for SP
 */
function getSuggestHeigh() {
    const $search = $('.search-mobile');
    const $searchField = $search.find('.form-control' + '.search-field');
    const $suggest = $search.find('.suggestions');
    const winH = $(window).height();
    const outerHeight = $searchField.outerHeight();
    if ($search.css('display') === 'block') {
        // Start：スティッキー対応。resize時のsuggestionモーダルのTOP位置追加
        const top = $searchField.offset().top - $(window).scrollTop();
        // End：スティッキー対応。resize時のsuggestionモーダルのTOP位置追加

        // Start：スティッキー対応。resize時のsuggestionモーダルの高さ変更
        const pos = $search.offset().top - $(window).scrollTop() + $search.height();
        const h = winH - pos;
        // End：スティッキー対応。resize時のsuggestionモーダルの高さ変更

        $suggest.css('top', top + outerHeight);
        $suggest.css('height', h);
    }
}

module.exports = function () {
    $(window).on('load resize', function () {
        getSuggestHeigh();
    });
};
